/**
 * Extends base Input theme with 3p Figma design.
 *
 * @see https://github.com/chakra-ui/chakra-ui/blob/092b20f3e93064c1db312062b76b420a7ed1703b/packages/theme/src/components/input.ts
 * @see https://www.figma.com/file/AVVZO09XE8fZ0uuOaJYcQg/B2C-Onboarding---for-Dev?node-id=2705%3A56301
 */
import { inputAnatomy as parts } from '@chakra-ui/anatomy';
import { ComponentStyleConfig } from '@chakra-ui/react';
import {
    PartsStyleFunction, PartsStyleObject, SystemStyleObject
} from '@chakra-ui/theme-tools';

import { baseControlTheme } from './base-control-theme';

const variantDefault: PartsStyleFunction<typeof parts> = (props) => {
    return { field: { ...baseControlTheme(props) } };
};
const size: Record<string, SystemStyleObject> = {
    default: {
        h: 14,
        px: 4,
        borderRadius: 'xl',
        fontSize: 'md',
        // TODO missing in design system
        letterSpacing: '0.15px',
        lineHeight: 'base'
    }
};
const sizes: Record<string, PartsStyleObject<typeof parts>> = { default: { field: size.default } };

export const Input: ComponentStyleConfig = {
    defaultProps: {
        size: 'default',
        variant: 'default'
    },
    variants: { default: variantDefault },
    sizes
};
